'use client';

import {
  asLink,
  EmbedField,
  isFilled,
  LinkToMediaField,
} from '@prismicio/client';

interface BlogVideoProps {
  embed: EmbedField;
  file: LinkToMediaField;
  url: string | null;
}

type EmbedShape = { html?: string | null; embed_url?: string | null };

const getEmbedHtml = (embed: EmbedField): string | null => {
  const value = embed as EmbedShape;
  return typeof value.html === 'string' && value.html.length > 0
    ? value.html
    : null;
};

const sizedIframeHtml = (html: string): string =>
  html.replace(/<iframe/i, '<iframe style="width:100%;height:100%"');

export function BlogVideo({ embed, file, url }: BlogVideoProps) {
  const embedHtml = isFilled.embed(embed) ? getEmbedHtml(embed) : null;
  const fileUrl = isFilled.linkToMedia(file) ? asLink(file) : null;
  const externalUrl = url && url.trim().length > 0 ? url.trim() : null;

  const hasContent = embedHtml || fileUrl || externalUrl;
  if (!hasContent) {
    return null;
  }

  return (
    <section className="w-full bg-white px-5 pt-8 md:px-10 md:pt-10 lg:px-20">
      <div className="mx-auto w-full max-w-[1280px]">
        <div className="relative w-full aspect-video overflow-hidden rounded-2xl bg-black [&>iframe]:h-full [&>iframe]:w-full">
          {embedHtml ? (
            <div
              className="absolute inset-0"
              dangerouslySetInnerHTML={{ __html: sizedIframeHtml(embedHtml) }}
            />
          ) : (
            <video
              className="absolute inset-0 h-full w-full object-contain"
              controls
              preload="metadata"
              playsInline
              src={(fileUrl ?? externalUrl) as string}
            >
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </div>
    </section>
  );
}
